import { Button } from "semantic-ui-react";
import styled from "styled-components";

const WalixButton = styled(Button)`
  &.button {
    border-radius: 0.71rem;
    font-family: "WorkSans";
    font-size: 1.3rem;
    font-weight: 600;
    line-height: 2rem;
    margin: 0;
    padding-bottom: 0.71rem;
    padding-left: 1.07rem;
    padding-right: 1.07rem;
    padding-top: 0.71rem;
  }
`;

export const PrimaryButton = styled(WalixButton)`
  &.button {
    background: ${props => props.theme.primaryButtonGradient};
    color: #fff;
    box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.1);
  }

  &.button:hover,
  &.button:active,
  &.button:focus {
    color: #fff;
  }
`;

export const TransparentButton = styled(WalixButton)`
  &.button {
    background-color: rgba(0, 0, 0, 0);
  }
`;
